import { EventEmitter, Injectable } from '@angular/core';
import { ActiveCartService, MultiCartService } from "@spartacus/cart/base/core";
import {
  GlobalMessageService,
  RoutingService,
  UserIdService
} from '@spartacus/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UigCheckoutAdapter } from './uig-checkout.adapter';
import {
  CheckoutData,
  PlaceOrderForm,
  PlaceOrderResponse
} from './uig-checkout.models';

@Injectable({
  providedIn: 'root',
})
export class UigCheckoutService {
  placeOrderForm: PlaceOrderForm;
  deliveryAddressMode = new EventEmitter<boolean>();
  pickup = new EventEmitter<boolean>();

  constructor(
    protected uigCheckoutAdapter: UigCheckoutAdapter,
    protected activeCartService: ActiveCartService,
    protected userIdService: UserIdService,
    protected multiCartService: MultiCartService,
    protected routingService: RoutingService,
    protected launchDialogService: LaunchDialogService,
    protected globalMessageService: GlobalMessageService
  ) {}

  createPlaceOrderForm(): PlaceOrderForm {
    this.placeOrderForm = new PlaceOrderForm();
    return this.placeOrderForm;
  }

  getCurrentPlaceOrderForm(): PlaceOrderForm {
    return this.placeOrderForm;
  }

  placeOrder(): Observable<PlaceOrderResponse> {
    let userId;
    this.userIdService
      .getUserId()
      .subscribe((occUserId) => (userId = occUserId))
      .unsubscribe();

    let cartId;
    this.activeCartService
      .getActiveCartId()
      .subscribe((activeCartId) => (cartId = activeCartId))
      .unsubscribe();

    return this.uigCheckoutAdapter
      .placeOrder(userId, cartId, this.placeOrderForm);
  }

  checkoutData(): Observable<CheckoutData> {
    let userId;
    this.userIdService
      .getUserId()
      .subscribe((occUserId) => (userId = occUserId))
      .unsubscribe();

    let cartId;
    this.activeCartService
      .getActiveCartId()
      .subscribe((activeCartId) => (cartId = activeCartId))
      .unsubscribe();

    return this.uigCheckoutAdapter.checkoutData(userId, cartId);
  }
}
